import React from 'react';

import { useIsAuthenticated, useMsal } from '@azure/msal-react';

import { Button } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';

import './bv-signout.scss';

const BVSignout: React.FunctionComponent = () => {
    const {
        instance
    } = useMsal();

    const isAuthenticated = useIsAuthenticated();

    return (
        <Button
            type="primary"
            className="bv-signout"
            disabled={!isAuthenticated}
            icon={<LogoutOutlined />}
            size={'large'}
            onClick={() => instance.logoutRedirect({ postLogoutRedirectUri: '/' })}
        >
            Logout
        </Button>
    );
}

export default BVSignout;